import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { SurveyCampaignItem } from '../../models/SurveyCampaignItem';
import { ApiService } from '@prikverwerker/services/api.service';
import { AlertService } from '@services/alert.service';
import { CreateSurveyCampaignModalComponent } from '../../components/new-survey-campaign-modal/create-survey-campaign-modal.component';
import { Observable } from 'rxjs';
import { Alert } from '@models/alert';
import { HttpErrorResponse } from '@angular/common/http';
import { DeleteConfirmationSurveyCampaignModalComponent } from '@prikverwerker/components/delete-confirmation-survey-campaign-modal/delete-confirmation-survey-campaign-modal.component';
import { Link } from '@prikverwerker/models/link';
import { ActionHelper } from '@prikverwerker/helpers/ActionHelper';

@Component({
  selector: 'mdk-overview-survey-campaigns',
  templateUrl: './overview-survey-campaigns.container.html',
  styleUrl: './overview-survey-campaigns.container.scss',
})
export class OverviewSurveyCampaignsContainer implements AfterViewInit, OnInit {
  public campaigns$!: Observable<SurveyCampaignItem[]>;
  public tableItemClassHelper = (state: string) => {
    switch (state.toLocaleLowerCase()) {
      case 'in verwerking':
        return 'warning';
      case 'geen peil data':
        return 'error';
      case 'afgewerkt':
        return 'success';
      default:
        throw new Error('onbekende status');
    }
  };

  @ViewChild('dataTable')
  dataTable!: ElementRef<HTMLElement>;

  @ViewChild(CreateSurveyCampaignModalComponent)
  private createSurveyComponent!: CreateSurveyCampaignModalComponent;

  @ViewChild(DeleteConfirmationSurveyCampaignModalComponent)
  private deleteConfirmationSurveyComponent!: DeleteConfirmationSurveyCampaignModalComponent;

  alert!: Alert | null;

  constructor(
    private apiService: ApiService,
    private alertService: AlertService
  ) {}

  hasDeleteSurveyCampaignAction(actionLinks: Link[]): boolean {
    if (!actionLinks) return false;

    const deleteSurveyCampaignActionLink: Link | undefined = actionLinks.find(
      (actionLink: Link) => actionLink.rel === this.apiService.deleteSurveyCampaignRel
    );

    return deleteSurveyCampaignActionLink !== undefined;
  }

  createNewSurveyCampaign(): void {
    this.apiService.newSurveyCampaign$.subscribe({
      next: (campaign) => this.createSurveyComponent.openModal(campaign),
      error: (error: HttpErrorResponse) =>
        this.alertService.onAlert({
          title: 'Kan geen prikcampagne maken',
          message: 'Mogelijks een verbindingsprobleem. ' + error.message,
          type: 'error',
        }),
    });
  }

  deleteSurveyCampaign(surveyCampaignId: string, surveyCampaignActionLinks: Link[]): void {
    if(!surveyCampaignActionLinks) return;

    const deleteSurveyCampaignActionLink: Link | undefined = ActionHelper.getActionLink(
                surveyCampaignActionLinks,
                this.apiService.deleteSurveyCampaignRel
              );

    try {
      this.deleteConfirmationSurveyComponent.openModal(surveyCampaignId, deleteSurveyCampaignActionLink);
    } catch (error) {
      console.error('Failed to open delete confirmation modal:', error);
      this.alertService.onAlert({
        title: 'Fout',
        message:
          'Kan de verwijderbevestiging niet openen. Probeer het opnieuw.',
        type: 'error',
      });
    }
  }

  handleCampaignDeleted() {
    this.refreshCampaigns();
  }

  clickCloseAlert() {
    this.alert = null;
  }

  private refreshCampaigns() {
    this.campaigns$ = this.apiService.surveyCampaignItems$;
  }

  ngOnInit() {
    this.refreshCampaigns();
  }

  ngAfterViewInit() {
    window.vl.dataTable.dress(this.dataTable.nativeElement);
  }

  handleRemoveCampaign(event: Event, surveyCampaignId: string, surveyCampaignActionLinks: Link[]) {
    event.stopPropagation(); // Stop event from navigating to campaign-details

    this.deleteSurveyCampaign(surveyCampaignId, surveyCampaignActionLinks);
  }
}
